/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { ArrowsUpDownIcon } from "@heroicons/react/24/outline";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { Link, useNavigate } from "@tanstack/react-router";
import { useCallback, useEffect, useMemo, useState } from "react";
import * as XLSX from "xlsx";

import { SubmitButton as Button } from "~/components/form/submit-button";
import {
  addExtraction,
  getExtraction,
  reloadExtraction,
} from "~/services/supervisor.services";
import { formatDate } from "~/utils/basic";
import { toast } from "react-toastify";
interface ISupervisorTableProps {
  data: any[];
  OriginalDateRange: any;
}

const ExtractionTable = ({
  data,
  OriginalDateRange,
}: ISupervisorTableProps) => {
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "asc" | "desc";
  }>({
    key: "ReceivedOnServer",

    direction: "desc",
  });
  type SelectedRowIds = Record<string, boolean>;
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [filters, setFilters] = useState<Record<string, string[]>>({});
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());
  const [selectedRowIds, setSelectedRowIds] = useState<SelectedRowIds>({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showSuccessModalReload, setShowSuccessModalReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloadSuccessMessage, setReloadSuccessMessage] = useState("");
  const [tableData, setTableData] = useState(data);
  const columnHelper = createColumnHelper<any>();
  const [allData] = useState<any[]>(data); // New state for all data
  console.log(allData);
  const [dateRange, setDateRange] = useState<{
    fromDate: string;
    toDate: string;
  } | null>(null);
  const [searchInputs, setSearchInputs] = useState<Record<string, string>>({});
  const roleid = localStorage.getItem("roleid");
  const debounce = (func: Function, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const debouncedSetFilters = useCallback(
    debounce((value: string, key: string) => {
      setFilters((prev) => ({
        ...prev,
        [key]: [value],
      }));
    }, 0),
    []
  );
  useEffect(() => {
    setTableData(data);
  }, [data]);

  useEffect(() => {
    const filtered = data.filter((row) =>
      Object.entries(filters).every(([key, searchValues]) => {
        const values = Array.isArray(searchValues)
          ? searchValues
          : [searchValues];
        return values.some((value) =>
          row[key]?.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    setFilteredData(filtered);
    setCurrentPage(0); // Reset to first page on search change
  }, [filters, data]);

  const fetchExtractionData = async () => {
    if (dateRange) {
      setLoading(true);
      console.log(OriginalDateRange);
      const { fromDate, toDate } = dateRange;

      const { data, status } = await getExtraction(fromDate, toDate);
      setLoading(false);
      if (status) {
        setTableData((data as any)?.data);

        setFilters({});
        setSearchInputs({});

        console.log("refreshed");
        setCurrentPage(0);
      } else {
        console.error("Failed to fetch extraction data.");
      }
    }
  };
  useEffect(() => {
    fetchExtractionData();
  }, [dateRange]);

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(0); // Reset to first page
  };
  const handleReload = async (taskId: string) => {
    setLoading(true);
    const { status, error } = await reloadExtraction(taskId);
    setLoading(false);
    if (status) {
      console.log("successmodal");
      setReloadSuccessMessage(`Task ${taskId} reloaded successfully!`);
      setShowSuccessModalReload(true);
      setTimeout(() => {
        setShowSuccessModalReload(false);
      }, 3000);
    } else {
      console.error("Reload failed:", error);
    }
  };
  const requestSort = useCallback((key: string) => {
    setSortConfig((prevConfig) => {
      let direction: "asc" | "desc" = "asc";
      if (prevConfig.key === key && prevConfig.direction === "asc") {
        direction = "desc";
      } else if (prevConfig.key === key && prevConfig.direction === "desc") {
        direction = "asc";
      }
      return { key, direction };
    });
  }, []);

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return filteredData;

    const sortableItems = [...filteredData];
    sortableItems.sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (aValue < bValue) {
        return sortConfig.direction === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === "asc" ? 1 : -1;
      }
      return 0;
    });

    return sortableItems;
  }, [filteredData, sortConfig]);

  const paginatedData = useMemo(() => {
    const start = currentPage * rowsPerPage;
    const end = start + rowsPerPage;
    return sortedData.slice(start, end);
  }, [sortedData, currentPage, rowsPerPage]);
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);
  // Handle page change
  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleInputChange = useCallback(
    (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setSearchInputs((prev) => ({
        ...prev,
        [key]: value,
      }));
      debouncedSetFilters(value, key);
    },
    [debouncedSetFilters]
  );

  const rememberPrevPath = () => {
    const path = window.location.hash.replace("#", "");
    sessionStorage.setItem("prevPath", path);
  };

  const createColumn = (key: string) => {
    const columnHeader = (
      <div className="p-2">
        <div className="flex flex-col gap-2 justify-center">
          <div>{key.replace(/([A-Z])/g, " $1").trim()}</div>
          <div className="flex items-center justify-center gap-2">
            <input
              type="text"
              value={searchInputs[key] || ""}
              onChange={handleInputChange(key)}
              // placeholder={`Search ${key}`}
              className="border border-gray-300 rounded"
            />
            <button onClick={() => requestSort(key)}>
              <ArrowsUpDownIcon className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    );

    return columnHelper.accessor(key as any, {
      header: columnHeader as any,
      cell: (props: any) => {
        const value = props?.getValue();
        if (
          key === "ReceivedOnServer" ||
          key === "AllocatedOn" ||
          key === "KeyedOn" ||
          key === "FileProcessedDateTime"
        ) {
          return formatDate(value, "dd/MM/yyyy hh:mm:ss a");
        }
        return value;
      },
    });
  };

  const columns = useMemo(() => {
    const baseColumns = [
      columnHelper.display({
        id: "select",
        header: () => (
          <input
            type="checkbox"
            checked={
              Object.keys(selectedRowIds).length === data.length &&
              data.length > 0
            }
            onChange={() => {
              const allSelected =
                Object.keys(selectedRowIds).length === data.length;
              const newSelectedIds: SelectedRowIds = {};
              if (!allSelected) {
                data.forEach((row) => {
                  newSelectedIds[row.TaskId] = true;
                });
              }
              setSelectedRowIds(newSelectedIds);
            }}
          />
        ),
        cell: (props: any) => (
          <input
            type="checkbox"
            checked={selectedRowIds[props.row.original.TaskId] || false}
            onChange={() => {
              setSelectedRowIds((prev) => {
                const newSelectedRowIds = { ...prev };
                if (newSelectedRowIds[props.row.original.TaskId]) {
                  delete newSelectedRowIds[props.row.original.TaskId];
                } else {
                  newSelectedRowIds[props.row.original.TaskId] = true;
                }
                return newSelectedRowIds;
              });
            }}
          />
        ),
      }),
      createColumn("TaskId"),
      createColumn("TaskName"),
      createColumn("ReceivedOnServer"),
      columnHelper.accessor("Actions", {
        header: () => (
          <div className="p-2">
            <div className="flex gap-2 justify-center">
              <div>View</div>
            </div>
          </div>
        ),
        cell: (props: any) => (
          <div>
            <Link
              to="/supervisor/worklist/view/$taskId"
              params={{ taskId: props?.row.original.TaskId }}
              onClick={rememberPrevPath}
              target="_blank"
            >
              <Button
                type="button"
                size="small"
                variant="secondary"
                className="text-primary ring-primary hover:bg-orange-100 active:bg-orange-200"
              >
                View
              </Button>
            </Link>
          </div>
        ),
      }),

      columnHelper.display({
        id: "reload",
        header: "Reload",
        cell: (props: any) => (
          <Button
            type="button"
            size="small"
            variant="secondary"
            className="text-primary ring-primary hover:bg-orange-100 active:bg-orange-200"
            onClick={() => {
              void handleReload(props.row.original.TaskId);
            }}
          >
            Reload
          </Button>
        ),
      }),
    ];

    // Add extra column if roleId === 16
    if (roleid === "16") {
      baseColumns.push(
        columnHelper.display({
          id: "testRule",
          header: "Test Business Rule",
          cell: (props: any) => (
            <Link
              to="/supervisor/worklist/edit/$taskId"
              params={{ taskId: props?.row.original.TaskId }}
              target="_blank"
            >
              <Button
                type="button"
                size="small"
                variant="secondary"
                className=""
                onClick={() => {
                  console.log(
                    `Testing business rule for TaskId: ${props.row.original.TaskId}`
                  );
                }}
              >
                Test Business Rule
              </Button>
            </Link>
          ),
        })
      );
    }

    // Add extra column if roleId === 18
    if (roleid === "18") {
      baseColumns.push(
        columnHelper.accessor("Actions", {
          header: () => (
            <div className="p-2">
              <div className="flex gap-2 justify-center">
                <div>Review</div>
              </div>
            </div>
          ),
          cell: (props: any) => (
            <div>
              <Link
                to="/supervisor/worklist/edit/$taskId"
                params={{ taskId: props?.row.original.TaskId }}
                onClick={rememberPrevPath}
              >
                <Button
                  type="button"
                  size="small"
                  variant="secondary"
                  className="text-primary ring-primary hover:bg-orange-100 active:bg-orange-200"
                >
                  {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                    />
                  </svg> */}
                  Review
                </Button>
              </Link>
              {/* <Button
                type="button"
                size="small"
                variant="transparent"
                onClick={() =>
                  navigate({
                    to: `/supervisor/worklist/edit/${props.row.original.TaskId}`,
                    params: {
                      taskId: `/supervisor/worklist/edit/${props.row.original.TaskId}`,
                    },
                  })
                }
                className="text-primary ring-primary hover:bg-orange-100 active:bg-orange-200"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                  />
                </svg>
              </Button> */}
            </div>
          ),
        })
      );
    }

    return baseColumns;
  }, [
    selectedRowIds,
    columnHelper,
    paginatedData,
    requestSort,
    tableData,
    filters,
    searchInputs,
    debouncedSetFilters,
    roleid, // Include dependency
  ]);

  const table = useReactTable({
    data: paginatedData,
    columns: columns as any,

    getCoreRowModel: getCoreRowModel(),
  });

  const ReloadMultiple = async () => {
    const keys = Object.keys(selectedRowIds);
    const selectedData = tableData.filter((row) => keys.includes(row.TaskId));

    if (selectedData.length === 0) {
      toast.error("No rows selected for reload.", {
        theme: "colored",
      });
      return;
    }
    setLoading(true);

    try {
      const fileIdToTaskIdMap = new Map<string, string>(
        selectedData.map((data) => [data.FileId, data.TaskId])
      );

      const uniqueTaskIds = Array.from(
        new Set(selectedData.map((data) => fileIdToTaskIdMap.get(data.FileId)))
      );

      for (const taskId of uniqueTaskIds) {
        if (taskId) {
          await handleReload(taskId);
        }
      }
    } catch (error) {
      console.error("Error reloading tasks:", error);
    } finally {
      setLoading(false);
    }
  };

  const exportToExcel = () => {
    const keys = Object.keys(selectedRowIds);
    const selectedData = tableData.filter((row) => keys.includes(row.TaskId));

    if (selectedData.length === 0) {
      toast.error("No rows selected for export.", {
        theme: "colored",
      });
      return;
    }
    const filteredData = selectedData.map(
      ({ TaskId, TaskName, ReceivedOnServer }) => ({
        TaskId,
        TaskName,
        ReceivedOnServer: formatDate(ReceivedOnServer, "dd-MM-yyyy hh:mm:ss a"),
      })
    );

    // Define headers with spaces
    const headers = ["Task Id", "Task Name", "Received On Server"];

    // Convert the filtered data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(filteredData, {
      header: ["TaskId", "TaskName", "ReceivedOnServer"],
    });

    // Set the header values and styles
    headers.forEach((header, index) => {
      const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: index })]; // Get the cell
      if (cell) {
        cell.v = header;
        cell.s = {
          font: {
            bold: true,
          },
        };
      }
    });

    // Set column widths based on header length
    const colWidths = headers.map((header) => ({ wch: header.length + 2 })); // +2 for padding

    worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "output Data");

    // Write the workbook to a file
    if (roleid === "16") {
      XLSX.writeFile(workbook, "BusinessRuleReport.xlsx");
    } else {
      XLSX.writeFile(workbook, "TestExtractionReport.xlsx");
    }
  };

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!event.target.files?.length) return;

    const file = event.target.files[0];

    if (file) {
      const fileType = file.type;
      const fileName = file.name;
      const isValidPDF =
        fileType === "application/pdf" &&
        fileName.toLowerCase().endsWith(".pdf");
      const isValidTIFF =
        (fileType === "image/tiff" || fileType === "image/x-tiff") &&
        (fileName.toLowerCase().endsWith(".tif") ||
          fileName.toLowerCase().endsWith(".tiff"));

      if (isValidPDF || isValidTIFF) {
        console.log("Valid file");
      }

      // Set a specific error message
      else {
        toast.error("Only PDF and TIFF files are allowed.", {
          theme: "colored",
        });

        console.error("Only PDF and TIFF files are allowed.");
        return;
      }
    }
    const fileName = file.name;
    const isFilenameInTaskName = data.some(
      (item: { TaskName: string }) => item.TaskName === fileName.split(".")[0]
    );
    if (isFilenameInTaskName) {
      toast.error(
        "Possible Duplicates Found. Please Select File with different name",
        {
          theme: "colored",
        }
      );
      return;
    }
    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64File = reader.result as string;
      const base64Content = base64File.split(",")[1] || base64File;

      setLoading(true);
      const { status, error } = await addExtraction(fileName, base64Content);
      setLoading(false);

      if (status) {
        setShowSuccessModal(true);
        const fromDate = OriginalDateRange[0];
        const toDate = OriginalDateRange[1];
        setDateRange({ fromDate, toDate });
        console.log(dateRange);
        setTimeout(() => {
          setShowSuccessModal(false);
          window.location.reload();
        }, 5000);
      } else {
        console.error("File upload failed:", error);
      }
    };

    reader.readAsDataURL(file);
  };

  return (
    <div className="w-full overflow-x-auto">
      <div className="flex justify-between mb-4">
        <div>
          <label>
            Rows per page:
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="ml-2 border border-gray-300 rounded"
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={sortedData.length}>All</option>
            </select>
          </label>
        </div>
        <div>
          <button
            onClick={exportToExcel}
            className="bg-orange-500 text-white py-2 px-4 rounded mr-1"
          >
            Export to Excel
          </button>
          <button
            onClick={ReloadMultiple}
            className="bg-orange-500 text-white py-2 px-4 rounded mr-1"
          >
            Reload
          </button>
          <label className="bg-orange-500 text-white py-2 px-4 rounded cursor-pointer">
            Upload file
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png,.tif,.tiff"
              onChange={handleFileUpload}
              className="hidden"
            />
          </label>
        </div>
      </div>
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th key={header.id} className="p-2">
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id} className="p-2">
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex justify-between items-center mt-4">
        <div className="p-4">
          {filteredData.length > 0
            ? "Showing " +
              paginatedData.length +
              " of " +
              filteredData.length +
              " entries"
            : "No data available for the selected dates."}
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => handlePageChange(Math.max(currentPage - 1, 0))}
            disabled={currentPage === 0}
            className="border border-gray-300 px-4 py-2 rounded mr-2"
          >
            Previous
          </button>
          <span>
            Page {currentPage + 1} of {totalPages}
          </span>
          <button
            onClick={() =>
              handlePageChange(Math.min(currentPage + 1, totalPages - 1))
            }
            disabled={currentPage >= totalPages - 1}
            className="border border-gray-300 px-4 py-2 rounded ml-2"
          >
            Next
          </button>
        </div>
      </div>
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="spinner-border animate-spin border-4 border-orange-400 border-t-transparent w-12 h-12 rounded-full"></div>
        </div>
      )}
      {showSuccessModalReload && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-4 rounded shadow-lg">
            <h2 className="text-lg font-semibold">{reloadSuccessMessage}</h2>
          </div>
        </div>
      )}
      {showSuccessModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white p-4 rounded shadow-lg">
            <p className="text-black">File uploaded successfully!</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExtractionTable;
